import { render, staticRenderFns } from "./SurgeryMap.vue?vue&type=template&id=f99346bc"
import script from "./SurgeryMap.vue?vue&type=script&lang=js"
export * from "./SurgeryMap.vue?vue&type=script&lang=js"
import style0 from "./SurgeryMap.vue?vue&type=style&index=0&id=f99346bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports